
import React from 'react';
import GasForm from './layout/GasForm';

export default function Faq() {
    return (
        <GasForm title={"FAQ"}
                    getAction="/faq/id/{id}"
                    saveAction="/cufaq"
                    showConfirmation={false}
        />
    );
}